import fetchAPI from '../utils/fetchAPI';

export default ({ xsrfToken, promoCode }: { xsrfToken: string; promoCode: string | number }) =>
  fetchAPI({
    method: 'POST',
    url: `/smb-profile/admarkt/verifyPromoCode/${promoCode}`,
    xsrfToken,
  });
